module.exports = "./app-dist/templates/home.component.55d3207cc238011f2a8e9751af398e2d.html";